export function isCurrentMemoryArtifact(artifact, state, loaded) {
  if (!artifact) return false;
  // Unstamped legacy cards contain no personal memory and remain compatible.
  if (artifact.memoryRevision === undefined) return !state?.revision;
  if (!loaded || !state || state.clearing || state.deleting) return false;
  return artifact.memoryRevision === state.revision;
}
